import React, { useEffect, useState } from 'react';

import { Card } from '@components/Card';
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import { groupCardColors } from '@presentation/Content/config';

import './styles.less';

interface IProps {
    title: string;
    description: string;
    className?: string;
    onClickGroup?: (tag?: string) => void;
    index?:number;
    randomSetValues?:number[];
}

const GroupCard = (props: IProps) => {
    const { title, description, className, onClickGroup, index, randomSetValues } = props;
    const [groupBackground, setGroupBackground] = useState(groupCardColors[0]);
    const style = ['tag_card_container', className].join(' ');

    if (!title) {
        return null;
    }

    useEffect(() => {
        setCardBackgroundColor();
    }, []);

    const onClick = () => {
        onClickGroup(title);
    };

    const setCardBackgroundColor = () => {
        setGroupBackground(groupCardColors[randomSetValues[index]]);
    };
    return (
        <Card className={style} containerStyle={{ background: groupBackground?.backgroundColor, border:`1px solid ${groupBackground?.borderColor}`}}>
            <div className="tag_card" onClick={onClick}>
                <Text
                    className="tag_heading"
                    fontFamilyVariant={FontFamilyVariant.bold2}
                    text={title}
                    textType={TextType.display2}
                />
                <Text
                    className="tag_description"
                    fontFamilyVariant={FontFamilyVariant.light}
                    text={description}
                    textType={TextType.caption1}
                />
            </div>
        </Card>
    );
};

export default GroupCard;
